<template>
  <div>
    <div id="patientStatusReport" class="wrrapper">
      <page-heading title="Patients Status Report" border></page-heading>
      <page-heading class="no-print">
        <template #content>
          <div class="flex align-center">
            <Select
              v-if="isAdmin"
              class="mr-2"
              styles="expenses-select"
              :input="handleBranchChange"
              placeholder="Select Branch"
              :options="brachData"
            />
            <Select
              placeholder="Filter by status"
              class="mr-1"
              :loading="loading"
              :options="[
                { name: 'Proccessed', status: 3 },
                { name: 'In Process', status: 1 }
              ]"
              :input="handleFilter"
            />
            <Select
              placeholder="Filter by service"
              :loading="loading"
              :options="listDoctors"
              :input="handleServiceHead"
            />
            <DateRangePicker @update="updateDate" ref="picker" />
            <Input
              class="mr-1"
              type="text"
              placeholder="Search..."
              @enter="handleSearch"
              id="search"
              v-model="searchQuery"
              icon="mdi-magnify"
              :handleSearch="handleSearch"
              :handleReset="handleReset"
              :reset="searchQuery"
            />
            <div class="flex align-center cursor">
              <img
                src="@/assets/print-icon.png"
                alt="print"
                class="print-report"
                @click="printReport"
              />
              <!-- <img
                src="@/assets/filter.svg"
                @click="resetFilters"
                width="24"  
                height="24"
              /> -->
              <span
                class="mdi mdi-reload"
                style="font-size: 2rem;"
                @click="resetFilters"
              ></span>
            </div>
            <ExportButtons @pdf="handleExportPdf" @excel="handleExportExcel" />
          </div>
        </template>
      </page-heading>
      <div class="status-report mb-base">
        <data-table
          :loading="loading"
          :cols="columns"
          :rows="statusReport"
          height="calc(100vh - 20rem)"
        >
        </data-table>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable.vue";
import DateRangePicker from "@/components/DateRangePIcker.vue";
import Input from "@/components/Input.vue";
import printDiv from "@/utils/print";
import Select from "@/components/Select.vue";
import ExportButtons from "@/components/ExportButtons.vue";
import { exportReportPdf, exportReportExcel } from "@/utils/reportExport";
import { formatedDate } from "@/utils/helpers";
import { mapActions, mapGetters } from "vuex";
import { permissionsMiddleWare } from "../../../utils/permissionsMiddleWare";
export default {
  components: {
    DateRangePicker,
    DataTable,
    Select,
    Input,
    ExportButtons
  },
  data() {
    return {
      filters: {
        end_date: null,
        start_date: null,
        service_head: undefined
      },
      searchQuery: "",
      isAdmin: false,
      brachData: [],
      columns: [
        { column: "serial", label: "#", width: "30" },
        {
          column: "date",
          label: "Date",
          sortable: true
        },
        {
          column: "name",
          label: "Patient",
          sortable: true
        },
        {
          column: "fatherOrHusbandName",
          label: "F/H Name",
          sortable: true
        },
        {
          column: "status",
          label: "Status",
          sortable: true
        },
        {
          column: "comment",
          label: "comment",
          sortable: true
        },
        {
          column: "temp_name",
          label: "Template Name",
          sortable: true
        },
        {
          column: "mr_no",
          label: "mr no",
          sortable: true
        },
        {
          column: "branch_name",
          label: "Branch Name",
          sortable: true
        },
        {
          column: "contactNumber",
          label: "contact number",
          sortable: true
        }
      ]
    };
  },
  methods: {
    ...mapActions("reports", ["listStatusReport"]),
    ...mapActions("expenses", ["fetchBranch"]),
    handleSearch() {
      if (permissionsMiddleWare("Report Status")) {
        this.filters.mr_no = this.searchQuery;
        this.listStatusReport(this.filters);
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action: Report Status"
          )
          .goAway("3000");
      }
    },
    handleReset() {
      if (permissionsMiddleWare("Report Status")) {
        this.filters.mr_no = "";
        this.searchQuery = "";
        this.listStatusReport();
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action: Report Status"
          )
          .goAway("3000");
      }
    },
    handleBranchChange(val) {
      if (permissionsMiddleWare("Report Status")) {
        if (val && val !== null) {
          this.filters.branchId = val.key;
          this.listStatusReport(this.filters);
        } else {
          this.listStatusReport(this.filters);
          this.filters.branchId = this.user?.userBranchId;
        }
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action: Report Status"
          )
          .goAway("3000");
      }
    },
    handleServiceHead(val) {
      if (permissionsMiddleWare("Report Status")) {
        if (this.searchQuery === "") {
          delete this.filters.mr_no;
        }
        this.filters.service_head = val?.id || undefined;
        this.listStatusReport(this.filters);
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action: Report Status"
          )
          .goAway("3000");
      }
    },
    updateDate(val) {
      if (permissionsMiddleWare("Report Status")) {
        (this.filters.end_date = formatedDate(val.endDate)),
          (this.filters.start_date = formatedDate(val.startDate));
        if (this.searchQuery === "") {
          delete this.filters.mr_no;
        }
        this.listStatusReport(this.filters);
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action: Report Status"
          )
          .goAway("3000");
      }
    },
    printReport() {
      const details = {
        title: "Patient's Status Report",
        printedBy: this?.$store?.getters["auth/userInfo"].full_name,
        startDate: this.filters.start_date,
        endDate: this.filters.end_date,
        imageUrl: this.bussinessLogoUrl,
        imageUrl2: this.selectedBranch
      };
      printDiv("patientStatusReport", details);
    },
    exportInput() {
      return {
        title: "Patient's Status Report",
        dateRange: {
          start: this.filters.start_date,
          end: this.filters.end_date
        },
        printedBy: this.user && this.user.full_name,
        businessLogoUrl: this.bussinessLogoUrl,
        branchLogoUrl: this.selectedBranch,
        cols: this.columns,
        rows: this.statusReport,
        fileName: "patient-status-report"
      };
    },
    handleExportPdf() {
      exportReportPdf(this.exportInput());
    },
    handleExportExcel() {
      exportReportExcel(this.exportInput());
    },
    handleFilter(val) {
      if (permissionsMiddleWare("Report Status")) {
        this.filters.status = val?.status || undefined;
        this.listStatusReport(this.filters);
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action: Report Status"
          )
          .goAway("3000");
      }
    },
    resetFilters() {
      this.filters = {};
      this.searchQuery = "";
      this.$refs.picker.handleReset();
      if (permissionsMiddleWare("Report Status")) {
        this.listStatusReport();
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action: Report Status"
          )
          .goAway("3000");
      }
    }
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      statusReport: "reports/statusReport",
      listDoctors: "doctors/listDoctors",
      settings: "bussiness/settings",
      selectedBranch: "expenses/selectedBranch",
      user: "auth/userInfo",
      fetchUserBranch: "expenses/fetchUserBranch"
    })
  },
  async mounted() {
    this.filters.branchId = this.user && this.user?.userBranchId;
    this.isAdmin = this.user.userRole.some(
      ({ name }) => name === "admin" || name === "doctor"
    );
    if (permissionsMiddleWare("Report Status")) {
      this.listStatusReport(this.filters);
    } else {
      this.$toasted
        .info(
          "This action cannot be performed by you due to insufficient authorization. Action: Report Status"
        )
        .goAway("3000");
    }
    this.bussinessLogoUrl = this.user && this.user?.bussinessLogoUrl;
    await this.fetchBranch();
    await this.fetchUserBranch?.map(elem => {
      this.brachData.push({ name: elem.name, key: elem.id });
    });
  }
};
</script>

<style>
@import "../../../assets/css/print.css";

#patientStatusReport .print-report {
  margin-right: 8px;
}

@media print {
  .status-report .table table tr td span {
    font-size: 0.6875rem !important;
    line-height: 15px !important;
    letter-spacing: 1px !important;
    white-space: nowrap;
  }

  .status-report .table table thead tr th .label {
    font-size: 0.7rem !important;
    line-height: 18px !important;
    white-space: nowrap;
  }

  .stats .stats__title {
    width: 200px;
    font-size: 0.7rem !important;
    line-height: 18px !important;
  }

  .stats .stats__value {
    font-size: 0.7rem !important;
    line-height: 18px !important;
  }

  .date-range-wrrapper,
  .custom-select .vs__dropdown-toggle {
    border: unset;
  }

  .date-range-wrrapper .calendar {
    border: none;
    padding: 0;
    display: none !important;
  }

  .date-range-wrrapper .calender {
    display: none !important;
  }

  .vs__actions {
    display: none;
  }
}
</style>
